/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Group_LearnInputs */

const en_directory_agent_readiness_group_learn = /** @type {(inputs: Directory_Agent_Readiness_Group_LearnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn`)
};

const zh_directory_agent_readiness_group_learn = /** @type {(inputs: Directory_Agent_Readiness_Group_LearnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`理解产品`)
};

/**
* | output |
* | --- |
* | "Learn" |
*
* @param {Directory_Agent_Readiness_Group_LearnInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_group_learn = /** @type {((inputs?: Directory_Agent_Readiness_Group_LearnInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Group_LearnInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_group_learn(inputs)
	return zh_directory_agent_readiness_group_learn(inputs)
});
export { directory_agent_readiness_group_learn as "directory.agent_readiness.group.learn" }